import React from "react";

export default function PrivacyPolicy() {
  return (
    <div style={{
      maxWidth: 900,
      margin: "2.5rem auto",
      padding: "2rem 1rem",
      background: "#fff",
      borderRadius: 10,
      boxShadow: "0 2px 16px #b1ae8d29"
    }}>
      <h1 style={{
        color: "#40652a",
        fontWeight: 700,
        fontSize: "2.1rem",
        marginBottom: "1.1rem"
      }}>
        Privacy Policy
      </h1>

      <p>
        <strong>Last updated:</strong> [30/07/2025]
      </p>

      <p>
        At Samrin Organic Mehndi, we respect your privacy and are committed to protecting your personal information.
        This Privacy Policy explains how we collect, use, and safeguard your information when you visit our website.
      </p>

      <h2 style={{marginTop: "1.4rem", color: "#7c6a43", fontSize: "1.2rem"}}>Information We Collect</h2>
      <ul style={{marginLeft: 22, marginBottom: 13}}>
        <li>Personal information you provide (such as name, email, phone) when contacting us or placing an order.</li>
        <li>Usage data collected automatically (such as browser type, pages visited, and referral source).</li>
      </ul>

      <h2 style={{marginTop: "1.1rem", color: "#7c6a43", fontSize: "1.2rem"}}>How We Use Your Information</h2>
      <ul style={{marginLeft: 22, marginBottom: 13}}>
        <li>To provide, operate, and maintain our website and services.</li>
        <li>To process orders and respond to your inquiries.</li>
        <li>To improve our website and customer service.</li>
        <li>For marketing or promotional communications (only with your consent).</li>
      </ul>

      <h2 style={{marginTop: "1.1rem", color: "#7c6a43", fontSize: "1.2rem"}}>Cookies</h2>
      <p>
        Our website may use cookies to enhance user experience. You can choose to disable cookies in your browser settings.
      </p>

      <h2 style={{marginTop: "1.1rem", color: "#7c6a43", fontSize: "1.2rem"}}>Sharing Your Information</h2>
      <p>
        We do not sell, trade, or rent your personal data to third parties. We may share information with trusted partners who help us operate our website or business, as long as they agree to keep it confidential.
      </p>

      <h2 style={{marginTop: "1.1rem", color: "#7c6a43", fontSize: "1.2rem"}}>Your Rights and Choices</h2>
      <p>
        You have the right to request access to, correction of, or deletion of your personal data we hold. Please contact us if you have any concerns.
      </p>

      <h2 style={{marginTop: "1.1rem", color: "#7c6a43", fontSize: "1.2rem"}}>Changes to this Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated date.
      </p>

      <h2 style={{marginTop: "1.1rem", color: "#7c6a43", fontSize: "1.2rem"}}>Contact Us</h2>
      <p>
        If you have questions about this Privacy Policy, please email us at <a href="mailto:yourmail@gmail.com">samrinmehnadiart@gmail.com</a>.
      </p>
    </div>
  );
}
